// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SiteReliabilitySignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="SiteReliabilitySignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M9.284 5.732a3.2 3.2 0 0 0-4.516 2.37L4.676 8.1a2.267 2.267 0 0 0-2.211 2.773 2.269 2.269 0 0 0 .798 4.39h9.774c-5.083-3.274-3.916-8.855-3.753-9.53" />
      <path d="M14.224 7.929a1.905 1.905 0 0 0-1.365 2.32 1.906 1.906 0 0 0 2.32 1.365 1.9 1.9 0 0 0 1.043-.7 1.9 1.9 0 0 0 .303-1.688 1.905 1.905 0 0 0-2.3-1.297" />
      <path d="M18.71 6.718A1.22 1.22 0 0 0 17.967 5.9l-2.873-1.094a1.3 1.3 0 0 0-.437-.082v.005a1.2 1.2 0 0 0-.34.078L11.444 5.9a1.23 1.23 0 0 0-.56.434l-.015.021A1.2 1.2 0 0 0 10.7 6.72l-.058.223c-.274 1.111-.305 2.191-.093 3.214l.043.195.008.03a6.9 6.9 0 0 0 1.069 2.331 8 8 0 0 0 .848 1.021 8.8 8.8 0 0 0 1.827 1.437.8.8 0 0 0 .312.106h.093a.8.8 0 0 0 .317-.107 8.9 8.9 0 0 0 2.396-2.084l-1.046-1.055a2.8 2.8 0 0 1-1.004.487 2.8 2.8 0 0 1-1.8-.128 2.83 2.83 0 0 1-1.6-3.517 2.835 2.835 0 1 1 5.042 2.479l.96.94a7 7 0 0 0 .596-1.248 7 7 0 0 0 .25-.888c.227-1.091.176-2.247-.151-3.437" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SiteReliabilitySignetIcon = /* @__PURE__ */ Object.assign(
  SiteReliabilitySignetIconComponent,
  { displayName: 'SiteReliabilitySignetIcon' },
);
